"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var Calculator = function Calculator(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.004 19.5a.5.5 0 01-.354-.146l-1.646-1.646-1.646 1.646a.501.501 0 01-.708-.708L5.297 17 3.65 15.354a.5.5 0 01.354-.854.5.5 0 01.354.146l1.646 1.646 1.646-1.646a.5.5 0 01.854.354.5.5 0 01-.146.354L6.711 17l1.646 1.646a.5.5 0 01-.353.854zm-2-9.5a.5.5 0 01-.5-.5v-2h-2a.5.5 0 010-1h2v-2a.5.5 0 011 0v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-.5.5zm9.5-2.5a.5.5 0 010-1h5a.5.5 0 010 1h-5zm0 11a.5.5 0 010-1h5a.5.5 0 010 1h-5zm0-2a.5.5 0 010-1h5a.5.5 0 010 1h-5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.004 23.5c-1.93 0-3.5-1.57-3.5-3.5V4c0-1.93 1.57-3.5 3.5-3.5h16c1.93 0 3.5 1.57 3.5 3.5v16c0 1.93-1.57 3.5-3.5 3.5h-16zm16-1c1.378 0 2.5-1.122 2.5-2.5v-7.5h-10v10h7.5zM1.504 20c0 1.378 1.121 2.5 2.5 2.5h7.5v-10h-10V20zm21-8.5V4c0-1.379-1.122-2.5-2.5-2.5h-7.5v10h10zm-11 0v-10h-7.5a2.502 2.502 0 00-2.5 2.5v7.5h10z"
  }));
};
Calculator.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const CalculatorIcon = exports.CalculatorIcon = (0, _createIconComponent.default)(Calculator, 'Calculator');